<page-toolbar [pageActions]="pageActions" [title]="translation ? translation.type : title"></page-toolbar>

<mat-progress-bar *ngIf="isLoading || !translation" mode="indeterminate"></mat-progress-bar>

<page-content *ngIf="!isLoading && !!translation">
  <mat-card appearance="outlined">
    <mat-card-title>{{translation.type}} -> {{translation.language}}</mat-card-title>
    <mat-card-content>
      <br>
      <ngx-json-viewer [expanded]="false" [json]="translation.data"></ngx-json-viewer>
    </mat-card-content>
  </mat-card>
</page-content>
